var React = require('react');

function Payment50x50 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Betalning","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"Betalkort","transform":"translate(8 13)","fill":"#000","fillRule":"nonzero"},React.createElement("path",{"d":"M2 4h30v5H2v12.003h30.003V2H2v2zM0 0h34.003v23.003H0V0zm21 16h8v2h-8v-2z","id":"Combined-Shape"}))));
}

Payment50x50.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50"};

module.exports = Payment50x50;

Payment50x50.default = Payment50x50;
